export default "__VITE_ASSET__6QB2oq_9__"